<template>
  <div class="my-setup">
    <div class="search" style="padding:10px 20px">
      <el-tabs v-model="activeName" type="card" @tab-click="onSearch">
        <el-tab-pane label="常见问题" name="first"></el-tab-pane>
        <el-tab-pane label="补充说明" name="second"></el-tab-pane>
      </el-tabs>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini" ref="formInline">
        <el-form-item label="事项名称：" prop="implName">
            <el-input v-model="formInline.implName"></el-input>
        </el-form-item>
        <el-form-item label="问题描述：" prop="knowledgeQuestion" v-if="activeName == 'first'">
          <el-input v-model="formInline.knowledgeQuestion"></el-input>
        </el-form-item>
        <el-form-item label="补充说明：" prop="content" v-else>
          <el-input v-model="formInline.content"></el-input>
        </el-form-item>
        <el-form-item label="状态：" prop="flag">
            <el-select v-model="formInline.flag">
            <el-option label="待审批" value="10"></el-option>
            <el-option label="审批通过" value="11"></el-option>
            <el-option label="审批驳回" value="12"></el-option>
            <el-option label="撤回" value="13"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="提出时间：">
            <el-date-picker
                v-model="time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
            </el-date-picker>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="resetForm('formInline')">重置</el-button>
        </el-form-item>
    </el-form>
    </div>

    <div class="tab">
        <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column
                type="index"
                label="#"
                width="50">
            </el-table-column>
            <el-table-column
                prop="implName"
                label="事项名称">
            </el-table-column>
            <el-table-column
                v-if="activeName == 'first'"
                prop="knowledgeQuestion"
                label="问题描述">
            </el-table-column>
            <el-table-column
                v-else
                prop="content"
                label="补充说明">
            </el-table-column>
            <el-table-column
                prop="createTime"
                label="提出时间">
            </el-table-column>
            <el-table-column
                prop="approveUserId_dictText"
                label="审批人">
            </el-table-column>
            <el-table-column
                prop="approveResult"
                label="采纳">
                <template slot-scope="scope">
                  {{scope.row.approveResult == '1' ? '是' : '否'}}
                </template>
            </el-table-column>
            <el-table-column
                prop="address"
                label="操作">
                <template slot-scope="scope">
                  <el-button @click="lookRow(scope.row)" type="text">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            style="margin-top:20px"
            background
            @current-change="onSearch('pagination')"
            :total="pagination.total"
            :current-page.sync="pagination.pageNo"
            :page-size="pagination.pageSize"
            layout="prev, pager, next, jumper">
        </el-pagination>
    </div>
    <!--  弹框  -->
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="30%">
      <ul class="rowInfo">
        <li>
          <p><span>事项名称：</span>{{rowInfo.implName}}</p>
        </li>
        <div v-if="activeName == 'first'">
          <li>
            <p><span>问题描述：</span>{{rowInfo.knowledgeQuestion}}</p>
          </li>
          <li>
            <p><span>答案描述：</span>{{rowInfo.knowledgeAnswer}}</p>
          </li>
        </div>
        <div v-else>
          <li>
            <p><span>补充说明：</span>{{rowInfo.content}}</p>
          </li>
          <li>
            <p><span>跳转事项：</span><i v-for="item in rowInfo.implementList" :key="item.id">{{item.implName}}</i></p>
          </li>
        </div>
        <li>
          <p><span>审批结果：</span>{{rowInfo.status == '0' ? '待审批' : (rowInfo.approveResult == '1' ? '已通过' : '未通过')}}</p>
        </li>
        <li>
          <p><span>审批时间：</span>{{rowInfo.updateTime}}</p>
        </li>
        <li>
          <p><span>备注：</span>{{rowInfo.remark}}</p>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/personApi'
import { mapState } from 'vuex'
export default {
    data() {
      return {
        formInline: {
          implName: '',
          knowledgeQuestion: '',
          content:'',
          flag:''
        },
        time:[],
        tableData: [],
        pagination: {
          pageSize: 10,
          pageNo: 1,
          total: 1
        },
        rowInfo:{},
        activeName:'first',
        dialogVisible:false
      }
    },
    computed:{
      ...mapState(["user"]),
    },
    mounted(){
      this.onSearch()
    },
    methods: {
      onSubmit() {
        let params = {
          ...this.formInline,
          beginTime:this.time[0],
          endTime:this.time[1],
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
          userId:this.user.info.id
        }
        api.myProblem(params).then(res => {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
          // console.log(res,'查询列表')
        }).catch(err => {
          console.log(err)
        })
        console.log(params)
      },
      resetForm(formName) {
        this.time = []
        this.$refs[formName].resetFields();
      },
      resetPage(){
        this.pagination = {
          pageSize: 10,
          pageNo: 1,
          total: 1
        }
      },
      onSearch(type) {
        if (type != 'pagination') {
          this.resetPage()
        }
        if (this.activeName == 'first') {
          this.onSubmit()
        }else {
          this.explain()
        }
      },
      explain(){
        let params = {
          ...this.formInline,
          beginTime:this.time[0],
          endTime:this.time[1],
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
          userId:this.user.info.id
        }
        api.myExplain(params).then(res => {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
          // console.log(res,'查询列表')
        }).catch(err => {
          console.log(err)
        })
        console.log(params)
      },
      // 查看
      lookRow(row){
        console.log(row)
        this.rowInfo = row
        this.dialogVisible = true
      }
    }
}
</script>

<style lang="less" scoped>
.my-setup{
    /* background: #fff; */
    // margin-top: 20px;
}
.search{
  background: #fff;
}
.tab{
    text-align: right;
    margin-top: 20px;
    padding: 20px;
    background: #fff;
}
.rowInfo{
  li{
    list-style: none;
    line-height: 2;
    p{
      display: flex;
      align-items: center;
      span{
        width: 25%;
      }
    }
    

  }
}
</style>